import React from 'react';

const KovVideo = ({ item }) => {
  return (
    <div className="kov-video">
      <div className="media-wrapper video clearfix">
        <div className=" video-gallery">
          <div className="col-xs-12">
            <div className="embed-responsive embed-responsive-16by9">
              <iframe
                width=""
                height=""
                frameBorder="0"
                allowFullScreen=""
                src={item.videoPlayback}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KovVideo;
